import React, { useState } from 'react';
import { Switch, ListItemIcon, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';

// import { LoadingButton } from '@mui/lab';
import DotsIcon from '../../../../assets/v2/DotsIcon';
import MenuItem from '../../Menu/MenuItem';
import Tooltip from '../../Tooltip';
import { SwitchWrapper } from '../../../SettingsTabs/styles';
import {
  StyledButton,
  StyledMenu,
  StyledFlatItems,
  StyledLineButton,
  StyledLoadingButton,
} from './ActionMenu.styles';
import { COLORS } from '../../../../theme';

function ActionMenu({ cell, column, row, skeleton, state: { loading } = {} }) {
  const [menuAnchor, setMenuAnchor] = useState();
  const isMenuOpen = Boolean(menuAnchor);
  const isHeader = !cell;
  const options = column?.ActionMenu;
  const items = isHeader ? options?.headerItems : options?.items;
  const flatItems = options?.flatItems;
  const isDisabled = options?.isDisabled;
  const toggleButton = options?.toggleButton;
  // For this moment inline items are not supported in Header (no designs yet)
  // const inlineItems = isHeader ? null : options?.inlineItems;
  // const [state, setState] = useState([]);

  const BUTTON_TYPE_TO_COLOR_CONVERTER = {
    starFavorite: COLORS.kinetikBlue,
    starNotFavorite: COLORS.black40,
    download: COLORS.black90,
    default: COLORS.black90,
  };

  if (skeleton) {
    return (
      <StyledButton disabled size="iconSmall">
        <DotsIcon />
      </StyledButton>
    );
  }

  if (!items && !flatItems && !toggleButton) {
    return null;
  }

  const calculateFilledColor = (item) => {
    if (item?.buttonType === 'star') {
      if (cell?.row?.original?.isAFavorite)
        return BUTTON_TYPE_TO_COLOR_CONVERTER.starFavorite;
      return BUTTON_TYPE_TO_COLOR_CONVERTER.starNotFavorite;
    }
    if (item?.buttonType === 'download')
      return BUTTON_TYPE_TO_COLOR_CONVERTER.download;
    return BUTTON_TYPE_TO_COLOR_CONVERTER.default;
  };

  const isLoading = (item) =>
    column?.clickedButtonType === item?.buttonType &&
    (row?.original?.isDownloading || row?.original?.isUpdating);

  const handleItemClick = (onClick) => {
    handleMenuClose();

    if (isHeader) {
      onClick();
    } else {
      onClick(row.original);
    }
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    if (items.length) {
      setMenuAnchor(event.currentTarget);
    }
  };

  const verifyConditions = (conditions) => {
    if (!conditions) {
      return true;
    }

    if (!Array.isArray(conditions)) {
      // eslint-disable-next-line no-console
      console.error('`conditions` need to be provided as an array.');
    }

    return conditions.every((condition) => {
      const key = Object.keys(condition)[0];
      const value = condition[key];
      return row.original[key] === value;
    });
  };

  return (
    <>
      {items && (
        <>
          <StyledButton
            $isHeader={isHeader}
            disabled={loading}
            size="iconSmall"
            onClick={handleMenuOpen}
          >
            <DotsIcon />
          </StyledButton>
          <StyledMenu
            anchorEl={menuAnchor}
            open={isMenuOpen}
            MenuListProps={{ 'aria-label': 'Menu' }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            onClose={handleMenuClose}
            onClick={(event) => event.stopPropagation()}
          >
            {items?.map(
              ({ icon, label, onClick, conditions }, index) =>
                verifyConditions(conditions) && (
                  <MenuItem
                    key={label + index.toString()}
                    onClick={() => handleItemClick(onClick)}
                  >
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText>{label}</ListItemText>
                  </MenuItem>
                ),
            )}
          </StyledMenu>
        </>
      )}
      {toggleButton && (
        <SwitchWrapper>
          {toggleButton?.map((item) => {
            const toggleSwitch = (
              <Switch
                size="small"
                checked={row.original.isActive}
                disabled={
                  !row.original.createdAt || item.isEdit?.[row.original.uuid]
                }
                onClick={() => item.onClick(row.original)}
              />
            );
            return item.tooltip ? (
              <Tooltip
                placement="top"
                arrow
                title={item.tooltip(row)}
                key={crypto.randomUUID()}
              >
                {toggleSwitch}
              </Tooltip>
            ) : (
              toggleSwitch
            );
          })}
        </SwitchWrapper>
      )}
      {flatItems && (
        <StyledFlatItems>
          {flatItems?.map((item, index) => {
            let FlatButton;
            if (item?.loadingButton) {
              FlatButton = (
                <StyledLoadingButton
                  $filledColor={calculateFilledColor(item)}
                  loading={isLoading(item)}
                  onClick={() => item.onClick(row?.original, item?.buttonType)}
                  key={index.toString()}
                  disbled={isDisabled}
                >
                  {item?.icon}
                </StyledLoadingButton>
              );
            } else
              FlatButton = (
                <StyledLineButton
                  $filledColor={calculateFilledColor(item)}
                  $size={item?.size}
                  onClick={() => item.onClick(row.original)}
                  key={index.toString()}
                  disbled={isDisabled}
                >
                  {item?.icon}
                </StyledLineButton>
              );

            return item.tooltip ? (
              <Tooltip
                placement="top"
                arrow
                title={item.tooltip(row)}
                key={crypto.randomUUID()}
              >
                {FlatButton}
              </Tooltip>
            ) : (
              FlatButton
            );
          })}
        </StyledFlatItems>
      )}
      {/* {
        inlineItems && (
          <>
            {
              inlineItems.map((item) => (
                <Box sx={{ marginRight: newLayout.spacing.s2 }}>
                  <Tooltip arrow placement="bottom" title={item.tooltip}>
                    <LoadingButton
                      loading={state.includes(`${row.original.uuid}-${item.tooltip}`)}
                      color="primary"
                      size="icon"
                      variant="outlined"
                      onClick={() => {
                        item.onClick(row.original, () => setState(state.filter((element) => element !== `${row.original.uuid}-${item.tooltip}`)));
                        setState([...state, `${row.original.uuid}-${item.tooltip}`]);
                      }}
                    >
                      {item.icon}
                    </LoadingButton>
                  </Tooltip>
                </Box>
              ))
            }
          </>
        )
      } */}
    </>
  );
}

ActionMenu.propTypes = {
  cell: PropTypes.object,
  column: PropTypes.object,
  row: PropTypes.object,
  skeleton: PropTypes.bool,
  state: PropTypes.object,
};

export { ActionMenu };
